// Node Modules
import React from "react";

import NewsletterSubscribeForm from "./components/newsletterSubscribeForm/newsletterSubscribeForm";

import "./contact.css";
import "./contactMobile.css";

class Contact extends React.Component {
  render() {
    return (
      <div className="content">
        <div className="contact">
          <div className="left-column">
            <p>Facebook:</p>
            <a
              className="mobileOnly"
              href="https://www.facebook.com/hechaNY"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>@hechaNY</p>
            </a>
            <p>Instagram:</p>
            <a
              className="mobileOnly"
              href="https://www.instagram.com/hecha_nyc"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>@hecha_nyc</p>
            </a>
            <p>Email:</p>
            <a
              className="mobileOnly"
              href="mailto:hechanyc@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>hechanyc@gmail.com</p>
            </a>
            <br />
            <p style={{ marginTop: "0.7rem" }}>Newsletter:</p>
            <div className="mobileOnly">
              <NewsletterSubscribeForm />
            </div>
          </div>
          <div className="right-column">
            <a
              href="https://www.facebook.com/hechaNY"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>@hechaNY</p>
            </a>
            <a
              href="https://www.instagram.com/hecha_nyc"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>@hecha_nyc</p>
            </a>
            <a
              href="mailto:hechanyc@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>hechanyc@gmail.com</p>
            </a>
            <br />
            <NewsletterSubscribeForm />
          </div>
        </div>
      </div>
    );
  }
}
export default Contact;
